import axios from "./axios";;

let Identity = function(config) {
  config.timeout = 30000;
  this.axios = axios(config);
  this.type = "identity";
};

export default Identity;
